export default __webpack_public_path__ + "static/media/aboutme.6b48a72e.svg";